import { createFileRoute } from '@tanstack/react-router';
import ProvidedJobPostListsIndexTemplate from '@/features/agent/provided_job_post_lists/templates/ProvidedJobPostListsIndexTemplate';

export const Route = createFileRoute('/agent/provided_job_post_lists/')({
  component: ProvidedJobPostLists,
  staticData: { title: 'リスト一覧' },
});

function ProvidedJobPostLists() {
  return <ProvidedJobPostListsIndexTemplate />;
}
